import { ActionTypes } from '../actions';

const initialState = {
  current: {},
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_USER:
      return { current: action.payload };
    default:
      return state;
  }
};

export default UserReducer;
